import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: "auto",
        backgroundColor: "primary.dark",
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" align="right">
          © Courtney McBeth
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
